import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-bg.png';
import SocialMedia from './SocialMedia';
import { SITE } from '../content/site';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-dark-gray text-white">
      <div className="container-width section-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Initiative */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src={logo} alt="Cardinal Grid" className="h-10 w-auto filter brightness-0 invert" />
              <div className="flex flex-col">
                <span className="text-xl font-poppins font-bold text-primary-red">CARDINAL GRID</span>
                <span className="text-sm font-montserrat text-light-blue">{SITE.kicker}</span>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">{SITE.description}</p>
            <p className="text-gray-400 text-sm mb-6">
              Code is released under {SITE.licenses.code}; notes under {SITE.licenses.notes}. Public data only.
            </p>
            <div className="mb-4">
              <h4 className="font-montserrat font-medium mb-3 text-light-blue">Follow the work</h4>
              <SocialMedia variant="dark" size="md" />
            </div>
          </div>

          {/* Sections */}
          <div>
            <h3 className="font-poppins font-semibold text-lg mb-4 text-light-blue">Sections</h3>
            <ul className="space-y-2">
              <li><Link to="/problem" className="text-gray-300 hover:text-white transition-colors">The Problem</Link></li>
              <li><Link to="/scorecard" className="text-gray-300 hover:text-white transition-colors">BA Forecast Scorecard</Link></li>
              <li><Link to="/sentinel" className="text-gray-300 hover:text-white transition-colors">Grid Data Sentinel</Link></li>
              <li><Link to="/forecaster" className="text-gray-300 hover:text-white transition-colors">Open Forecaster</Link></li>
              <li><Link to="/notes" className="text-gray-300 hover:text-white transition-colors">Technical Notes</Link></li>
              <li><Link to="/methods" className="text-gray-300 hover:text-white transition-colors">Data &amp; Methods</Link></li>
              <li><Link to="/contribute" className="text-gray-300 hover:text-white transition-colors">Contribute</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About</Link></li>
            </ul>
          </div>

          {/* Maintainer */}
          <div>
            <h3 className="font-poppins font-semibold text-lg mb-4 text-light-blue">Maintainer</h3>
            <p className="text-gray-300">{SITE.maintainer.name}</p>
            <p className="text-sm text-gray-400 mb-4">{SITE.maintainer.title}</p>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>
                <a href={`mailto:${SITE.maintainer.email}`} className="hover:text-white">{SITE.maintainer.email}</a>
              </p>
              <p>
                Project inbox: <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
              </p>
              <p>
                <a href={SITE.github} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                  github.com/cardinalgrid
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {year} Cardinal Grid. An independent, open initiative. Analyses rely on public data and represent the maintainer's own views.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
